export default __webpack_public_path__ + "static/media/TECDlogoImage.c0bc6246.png";